import fetch from '../Services/fetch'

export default () => (dispatch) => {
  
  dispatch(fetch())

}
